import React, { useState } from 'react';
import '../CSS/Records.css'
import styles from '../CSS/AgentHome.module.css';

import { IoMdSearch } from "react-icons/io";

import { GoArrowRight } from "react-icons/go";

import { useAuth } from '../AuthContext';
import { useRef } from 'react';
import { useEffect } from 'react';
import Loading from '../Components/Loading';
import Error from '../Components/Error';
import { useNavigate } from 'react-router-dom';

const UsersRec = () => {
    const { fetchData, postData } = useAuth();
    const navigate = useNavigate()

    const [records, setRecords] = useState([]);
    const [userId, setUserId] = useState('')

    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');

    const [users, setUsers] = useState({
        total: 0,
        today: 0,
        yesterday: 0
    });

    const recordsPerPage = 100;
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(users.total / recordsPerPage);

    const displayError = (message) => {
        setIsError(true);
        setErrorText(message);

        const timerId = setTimeout(() => {
            setIsError(false);
            setErrorText('');
        }, 1500);

        return () => clearTimeout(timerId);
    };

    async function getData(page = 1) {
        setLoader(true);

        try {
            const data = await fetchData('/admin/users/list?page=' + page);
            setLoader(false);

            setRecords(data.records || []);

            setUsers({
                ...users,
                total: data.totalUsers,
                today: data.todayUsers,
                yesterday: data.yesterdayUsers
            });
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    useEffect(() => {
        getData(currentPage)
    }, [])


    const goToPage = (pageNum) => {
        if (pageNum >= 1 && pageNum <= totalPages && pageNum !== currentPage) {
            setCurrentPage(pageNum);
        }
    };

    const renderPagination = () => {
        const pages = [];
        const edgeCount = 3;

        const addPage = (p) => {
            pages.push(
                <button
                    key={p}
                    onClick={() => goToPage(p)}
                    className={p === currentPage ? "active" : ""}
                >
                    {p}
                </button>
            );
        };

        pages.push(
            <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1} key="prev">
                &lt;
            </button>
        );

        for (let i = 1; i <= Math.min(edgeCount, totalPages); i++) addPage(i);

        if (currentPage > edgeCount + 1) pages.push(<span key="start-ellipsis">...</span>);

        const startMiddle = Math.max(edgeCount + 1, currentPage - 1);
        const endMiddle = Math.min(totalPages - edgeCount, currentPage + 1);

        for (let i = startMiddle; i <= endMiddle; i++) {
            if (i <= totalPages) addPage(i);
        }

        if (currentPage < totalPages - edgeCount) pages.push(<span key="end-ellipsis">...</span>);

        for (let i = totalPages - edgeCount + 1; i <= totalPages; i++) {
            if (i > edgeCount) addPage(i);
        }

        pages.push(
            <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages} key="next">
                &gt;
            </button>
        );

        return <div className="pagination">{pages}</div>;
    };

    return (
        <div className={styles.dashboard}>
            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className={styles.topbar}>
                <div className={styles.left}>
                    <h1>User Records</h1>
                </div>

                <div className={styles.right} style={{
                    display: "flex",
                    alignItems: "center",
                }} onClick={() => navigate(-1)}>
                    <div>Go Back</div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20
                    }}>
                        <GoArrowRight />
                    </div>
                </div>
            </div>

            <div className="summary-container">
                <div className="card">
                    <h2>Total User's</h2>
                    <p className="amount">{users.total.toLocaleString()}</p>
                </div>
                <div className="card">
                    <h2>Today's Users</h2>
                    <p className="amount">{users.today.toLocaleString()}</p>
                </div>
                <div className="card">
                    <h2>Yesterday's Users</h2>
                    <p className="amount">{users.yesterday.toLocaleString()}</p>
                </div>
            </div>

            <div className="search-sec">
                <div className="ss-left"></div>
                <div className="ss-right">
                    <input type="text" placeholder='Enter userid' value={userId} onChange={(e) => setUserId(e.target.value)} />
                    <button className="search-btn" onClick={() => navigate('/user/record?userId=' + userId)}>
                        <IoMdSearch />
                    </button>
                </div>
            </div>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Date & Time</th>
                            <th>Email</th>
                            <th>Status</th>
                            <th>Referred By</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {records.map((w, i) => (
                            <tr key={i}>
                                <td>
                                    <div>{w.date}</div>
                                </td>
                                <td>
                                    <div>{w.email}</div>
                                    <div className="subtext">Account ID: {w.id}</div>
                                </td>
                                <td>
                                    <div>{w.status ? 'Active' : 'Banned'}</div>
                                </td>
                                <td>
                                    <div>{w.referred_by || 'Not Invited'}</div>
                                </td>
                                <td>
                                    <button className="btn approve" onClick={() => navigate('/user/record?userId=' + w.id)}>View user</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {renderPagination()}
        </div>
    )
}

export default UsersRec